/* ---------- Hero: who we are and what we do, beside a road ---------- */
.hero {
  /* Same overlap as the home hero: cancel the flow space the sticky header reserves. */
  margin-top: calc(-1 * (var(--header-h) + 2 * var(--header-margin)));
  padding-block: calc(var(--header-h) + 2 * var(--header-margin) + var(--sp-12)) var(--sp-16);
  background: var(--surface-alt);
}
.heroGrid {
  display: grid;
  gap: var(--sp-12);
  align-items: center;
}
.heroText > * {
  max-width: 38rem;
}
.heroTitle {
  /* Room under the breadcrumb, which the dropped eyebrow label used to provide. */
  margin-top: var(--sp-6);
  font-size: clamp(2.4rem, 3.4vw + 1rem, 4.25rem);
  line-height: 1.04;
  letter-spacing: -0.035em;
  text-wrap: balance;
}
.heroLead {
  margin-top: var(--sp-5);
  font-size: var(--fs-lg);
  color: var(--text);
}
.figures {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-3) var(--sp-10);
  margin-top: var(--sp-8);
  padding-top: var(--sp-5);
  border-top: 1px solid var(--border-strong);
  color: var(--text-muted);
}
.figures strong {
  margin-right: 0.3em;
  font-family: var(--font-display);
  font-size: var(--fs-2xl);
  font-weight: 700;
  letter-spacing: var(--tracking-heading);
  color: var(--text-strong);
}
.heroImage {
  border-radius: var(--radius-lg);
  box-shadow:
    0 0 0 1px var(--border),
    var(--shadow-lg);
}
@media (min-width: 64rem) {
  .heroGrid {
    grid-template-columns: minmax(0, 1.05fr) minmax(0, 1fr);
    gap: var(--sp-16);
  }
}

/* ---------- The story: the idea the company started from ---------- */
.story {
  display: grid;
  gap: var(--sp-10);
  align-items: center;
}
.storyImage {
  border-radius: var(--radius-lg);
  box-shadow:
    0 0 0 1px var(--border),
    var(--shadow-lg);
}
.storyTitle {
  font-size: clamp(2.25rem, 2.6vw + 1rem, 3.5rem);
  line-height: 1.05;
  letter-spacing: -0.03em;
}
.storyText p {
  max-width: 36rem;
  margin: var(--sp-5) 0 0;
  font-size: var(--fs-md);
  color: var(--text);
}
/* Mission and vision side by side, each under its own rule. */
.mission {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 14rem), 1fr));
  gap: var(--sp-6) var(--sp-8);
  margin: var(--sp-8) 0 0;
}
.mission div {
  padding-top: var(--sp-4);
  border-top: 2px solid var(--accent);
}
.mission dt {
  font-weight: 700;
  color: var(--text-strong);
}
.mission dd {
  margin: var(--sp-2) 0 0;
  color: var(--text);
}
@media (min-width: 64rem) {
  .story {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: var(--sp-16);
  }
}

/* ---------- Beliefs: four on hairline rows ---------- */
.beliefs {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 15rem), 1fr));
  gap: var(--sp-10) var(--sp-10);
}
.beliefs li {
  padding-top: var(--sp-5);
  border-top: 1px solid var(--border-strong);
}
.beliefs h3 {
  margin-bottom: var(--sp-3);
  font-size: var(--fs-xl);
  line-height: var(--lh-snug);
}
.beliefs p {
  margin: 0;
  color: var(--text);
}
@media (min-width: 64rem) {
  .beliefs {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

/* ---------- Where our clients are: the header beside the map ---------- */
.where {
  display: grid;
  gap: var(--sp-8);
  align-items: center;
}
@media (min-width: 64rem) {
  .where {
    grid-template-columns: minmax(0, 4fr) minmax(0, 7fr);
    gap: var(--sp-16);
  }
}

.whereText p {
  max-width: 30rem;
  margin: var(--sp-4) 0 var(--sp-5);
  font-size: var(--fs-md);
  color: var(--text);
}
.whereLink {
  font-weight: 600;
  color: var(--text-strong);
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.3em;
}
.whereLink:hover {
  color: var(--accent-text);
}

/* ---------- Leadership ---------- */
.leaders {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 17rem), 1fr));
  gap: var(--sp-10) var(--sp-8);
}
@media (min-width: 64rem) {
  .leaders {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
